module.exports = __webpack_public_path__ + "static/owens-preferred2-4bdd5df29eea499c63fcc11228b8ff98.png";